export default "__VITE_ASSET__DXK2u_ii__"